import { gql } from "@apollo/client";

export const getTopPerformerLenses = gql`
    query topPerformerLenses($input: TopPerformerLensesInput!) {
        topPerformerLenses(input: $input) {
            lenses {
                lens {
                    id
                    name
                    iconUrl
                    organizationId
                    lensAccountId {
                        lensSpaceId
                    }
                }
                status
                qualifiedPosters
                postersThreshold
                award {
                    amountMilliUsd
                    awardedMonth
                    paidOn
                }
            }
            enrolledCount
            awardedCount
            totalEarnedMilliUsd
        }
    }
`;
